import React from "react";
import classes from "./fileUplaodLoader.module.css";

export const FileUploadLoader = ({ message }) => {
  return (
    <div className={classes.backDrop}>
      <div className={classes.box}>
        <h2 className={classes.box__title}>{message}</h2>

        <div className={classes.box__bar}>
          <span className={classes.box__bar__title}>Uploading file...</span>

          <div className={classes.box__bar__animate}>
            <div className={classes.box__bar__animation}></div>
          </div>
        </div>
      </div>
    </div>
  );
};
